import React from 'react';
import { Play, RefreshCw, Search } from 'lucide-react';
import { UniverseKey, UNIVERSE_LABELS } from '../constants/stockUniverses';

const UNIVERSES: UniverseKey[] = ['SENSEX30', 'NIFTY50', 'NIFTYNEXT50', 'NIFTY100', 'NIFTY200', 'NIFTY500', 'ALL', 'HOLDINGS'];

interface ControlsProps {
  isLoading: boolean;
  error: string | null;
  onRunScan: () => void;
  onLoadDemo?: () => void;
  query: string;
  onQueryChange: (q: string) => void;
  showNoSignal: boolean;
  onToggleNoSignal: () => void;
  universe: UniverseKey;
  onUniverseChange: (u: UniverseKey) => void;
}

export function Controls({
  isLoading, error, onRunScan, onLoadDemo,
  query, onQueryChange,
  showNoSignal, onToggleNoSignal,
  universe, onUniverseChange,
}: ControlsProps) {
  return (
    <section className="card controls">
      <div className="controls-content">
        <div className="controls-top-row">
          <div>
            <h2>Stock Scanner Controls</h2>
            <p className="hint">Run the swing strategy on your tracked universe</p>
          </div>
          <div className="control-row">
            <label className="toggle-label">
              <span className="toggle-text">No Signal</span>
              <div className={`toggle-switch ${showNoSignal ? 'on' : ''}`} onClick={onToggleNoSignal}>
                <div className="toggle-thumb" />
              </div>
            </label>
            {onLoadDemo && (
              <button className="btn btn-secondary" onClick={onLoadDemo} disabled={isLoading}>
                Load Demo Data
              </button>
            )}
            <button className="btn btn-primary" onClick={onRunScan} disabled={isLoading}>
              {isLoading ? (
                <><RefreshCw size={18} className="spin" style={{ marginRight: '8px' }} />Scanning...</>
              ) : (
                <><Play size={18} style={{ marginRight: '8px' }} />Run Scan</>
              )}
            </button>
          </div>
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="universe-filter">
          {UNIVERSES.map(u => (
            <button
              key={u}
              className={`universe-chip${universe === u ? ' active' : ''}`}
              onClick={() => onUniverseChange(u)}
            >
              {UNIVERSE_LABELS[u]}
            </button>
          ))}
        </div>

        <div className="search-bar">
          <Search size={18} className="search-icon" />
          <input
            type="text"
            placeholder="Search symbol…  e.g. RELIANCE, INFY, TMCV"
            value={query}
            onChange={e => onQueryChange(e.target.value)}
            className="search-input"
          />
          {query && (
            <button className="search-clear" onClick={() => onQueryChange('')} aria-label="Clear">✕</button>
          )}
        </div>
      </div>
    </section>
  );
}
